import * as React from 'react'

function IconGoLesson(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={26}
      height={28}
      viewBox="0 0 26 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.584 1.91h7.597c3.939 0 7.13 3.175 7.13 7.093v9.994c0 3.918-3.194 7.094-7.13 7.094H9.584M1.766 14h13.393"
        stroke={props.color}
        strokeWidth={3}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M12.528 19.528l4.284-3.66a2.456 2.456 0 000-3.74l-4.284-3.66"
        stroke={props.color}
        strokeWidth={3}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default IconGoLesson
